import {Box, Dialog, Typography} from '@mui/material';
import {useRouter} from 'next/router';
import {Image} from '@jobseeker/lotus/components/Image';
import {CrossIcon, HiristDone} from '@jobseeker/lotus/assets/icons';
import {useEffect, useState} from 'react';
import {talentBridgeContants} from '../utils';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

const TBDialog = () => {
  const theme = useWrappedTheme();
  const router = useRouter();
  const campaignLogin = router.query.campaignLogin;
  const [dialogOpen, setdialogOpen] = useState<boolean>(
    router.query.ref === talentBridgeContants.refCode_perm ? true : false
  );

  const [month, setMonth] = useState<string | null>(null);
  const [city, setCity] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const raw = localStorage.getItem('talentBridgeMonthCity');
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        if (parsed.month) setMonth(String(parsed.month));
        if (parsed.city) setCity(String(parsed.city));
      }
    } catch (e) {
      console.log('Error parsing talentBridgeMonthCity', e);
    }
  }, []);

  if (!city || !month) return null;

  return (
    <Dialog
      open={dialogOpen}
      onClose={() => {
        const updatedQuery = {...router.query};
        delete updatedQuery.ref;
        delete updatedQuery.campaignLogin;

        router.replace(
          {
            pathname: router.pathname,
            query: updatedQuery,
          },
          undefined,
          {shallow: true}
        );

        setdialogOpen(false);
      }}
      fullWidth
      sx={{
        '.MuiDialog-paper': {
          maxWidth: 620,
          borderRadius: 3,
        },
      }}
    >
      <Box display={'flex'} justifyContent={'flex-end'}>
        <Box
          onClick={() => {
            const updatedQuery = {...router.query};
            delete updatedQuery.ref;
            delete updatedQuery.campaignLogin;

            router.replace(
              {
                pathname: router.pathname,
                query: updatedQuery,
              },
              undefined,
              {shallow: true}
            );
            setdialogOpen(false);
          }}
          sx={{
            cursor: 'pointer',
            position: 'relative',
            width: 50,
            height: 50,
            backgroundColor: 'blue.lightNavy',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 1.5,
            mt: 1,
            '&:hover': {
              backgroundColor: 'white',
              boxShadow: '0 6px 14px 0 rgba(0, 0, 0, 0.09)',
            },
          }}
        >
          <Image src={CrossIcon} alt="cross-icon" height={12} width={12} />
        </Box>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        mt={1}
        px={{xxs: 5, md: 10}}
        pb={2}
      >
        <Image src={HiristDone} alt="done" width={45} height={45} />
        <Typography
          mt={2}
          fontSize={{
            xxs: theme.typography.pxToRem(20),
            md: theme.typography.pxToRem(24),
          }}
          fontWeight={700}
          color={'#212529'}
        >
          {campaignLogin
            ? 'Looks like you’ve already registered for this event.'
            : `You have successfully registered for Talent Bridge, ${city}.`}
        </Typography>
        <Typography
          mt={1.5}
          fontSize={{
            xxs: theme.typography.pxToRem(14),
            md: theme.typography.pxToRem(16),
          }}
          fontWeight={400}
          mx={-4}
          mb={5}
          color="#212529"
        >
          The jobs will go live in {month}. You will receive updates on your
          email. Meanwhile, you can check your jobfeed on hirist.tech.
        </Typography>
      </Box>
    </Dialog>
  );
};

export default TBDialog;
